import React from 'react'
import { Box } from '@mui/material'
import CreateDraftServiceTemplateList from 'components/configured-service/CreateDraftConfiguredServiceDialog/CreateDraftServiceTemplateList'
import DraftServiceDetails from './DraftServiceDetails'

const DraftServiceSelectionArea = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
        <CreateDraftServiceTemplateList />
      </Box>
      <DraftServiceDetails />
    </Box>
  )
}

export default DraftServiceSelectionArea
